import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { DialogCloseTokenComponent } from 'src/app/shared/components/dialog-close-token/dialog-close-token.component';

@Injectable({
  providedIn: 'root'
})
export class AuthLogoutService {

  constructor(private readonly dialog: MatDialog, private readonly authService: MsalService) {}

  showExpiredDialogAndLogout() {
    const dialogRef = this.dialog.open(DialogCloseTokenComponent, {
      disableClose: true,
      width: '500px',
    });

    setTimeout(() => {
      dialogRef.close();
      sessionStorage.removeItem('tokenActive');
      this.authService.logout();
    }, 5000);
  }
}